import gql from "graphql-tag";
import {ClientFieldsFragment} from "./client.gql";

export const InvoicesQuery = gql`
query Invoices($where: InvoiceWhereInput!) {
  invoices(where: $where) {
    id
    number
    filename
    type
    createdAt
    data
     clientOrders {
      client { id ibanNumbers }
    }
    payments {
    	id
      paymentDate
      amount
      dueDate
      paid
      createdAt
    }
  }
}`;

export const InvoiceQuery = gql`
${ClientFieldsFragment}
query Invoice($id: ID!) {
  client: clients(where: {
    clientOrders_some: {
      invoice: {id: $id}
    }
  }) {
    ...ClientFields
  }
  invoice(where: {id: $id}) {
    createdAt
    data
    filename
    id
    number
    type
    clientOrders {
      id
      deliveryEndDate
      deliveryDate
      orderDiscount
      delivery
      productOrders {
        id
        productDescription
        priceExcl
        product {
          name
          unit
          amount
          type
          avgWeight
          availableAsAlternativeUnitFor
          alternativeUnit
          category { code }
          vat
        }
        ambassadorDiscount
        quantity
        deliveries { id }
      }
    }
    payments {
      id
      paymentDate
      amount
      dueDate
      paid
      createdAt
    }
  }
}`;

export const InvoiceUpdateMutation = gql`
mutation InvoiceUpdate($id: ID!, $data: InvoiceUpdateInput!) {
  updateInvoice(
    where: {id: $id}
    data: $data
  ) {
    id
  }
}
`;
